import Button from '@ui/buttons/Button'
import { OrderConfigResponse } from '@ca/common'
import {
  DealSettings,
  getConvertedPrice,
  shouldShowMonthly,
} from '@ca/common/types'
import DetailRow from '@ui/elements/DetailRow'
import PriceInfo from '@/price/PriceInfo'
import { OrderState, ResolvedDealsContext } from '@order/hooks/state/orderState'
import { useOrderResultTotal } from '@order/hooks/useOrderTotal'
import { DiscountOption } from '@order/orderTypes'
import { useTotalDiscountAmount } from '@order/useDiscounts'
import { useTranslation } from 'react-i18next'

interface Props {
  result: OrderConfigResponse | null
  order: OrderState
  deals: ResolvedDealsContext
  discounts: DiscountOption[]
  className?: string
  settings?: DealSettings
  handleOpen?: () => void
}

export default function DiscountDetailsRow(props: Props) {
  const { t } = useTranslation(['summary'])
  const { result, order, deals, discounts, className, handleOpen, settings } =
    props

  const orderTotal = useOrderResultTotal({ result, order, deals })
  const discountAmount = useTotalDiscountAmount({
    orderTotal,
    discounts,
  })

  const priceSuffix = settings?.priceSuffix
  const showMonthly = shouldShowMonthly(settings)

  return (
    <DetailRow
      className={className}
      title={t('summary:label.discounts')}
      icon="discount"
      onPress={result ? handleOpen : undefined}
      success={discountAmount.hasDiscounts}
    >
      {!!discountAmount.custom && (
        <PriceInfo
          suffix={showMonthly ? priceSuffix : undefined}
          value={
            showMonthly
              ? getConvertedPrice(discountAmount.custom, settings)
              : discountAmount.custom
          }
          size="default"
        />
      )}
      {!!handleOpen && !discountAmount.custom && (
        <Button
          size="xs"
          variant="outlined"
          disabled={!result}
          label={t('ui:add')}
          onPress={handleOpen}
        />
      )}
    </DetailRow>
  )
}
